import React, { useState } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalFooter,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import i18n from '@/utils/i18n';
import { LayoutStoreInstance } from '../../../../LayoutStore';
import { useLinkOrderFulfillmentPicturesMutation } from '../../../../graphql/mutations/linkOrderFulfillmentPictures.generated';

type LinkOrderFulfillmentPicturesModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  pictureIds: string[];
  onComplete: () => void;
};

const LinkOrderFulfillmentPicturesModal = ({
  isOpen,
  setIsOpen,
  pictureIds,
  onComplete,
}: LinkOrderFulfillmentPicturesModalProps) => {
  const [orderFulfillmentId, setOrderFulfillmentId] = useState<string>('');
  const [linkOrderFulfillmentPictures] =
    useLinkOrderFulfillmentPicturesMutation();

  async function execute() {
    if (pictureIds.length === 0 || orderFulfillmentId.length === 0) {
      setIsOpen(false);
      return;
    }

    const res = await linkOrderFulfillmentPictures({
      variables: {
        order_fulfillment_id: orderFulfillmentId,
        picture_ids: pictureIds,
      },
    });
    if (res.errors || res.data == null) {
      LayoutStoreInstance.setError(
        i18n.t('OrderFulfillmentPictures:linkError'),
      );
      console.log(res.errors);
    }

    setIsOpen(false);
    onComplete();
  }

  return (
    <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <ModalHeader>
        <p>{i18n.t('OrderFulfillmentPictures:linkHeader')}</p>
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label className="me-2">
              {i18n.t('OrderFulfillmentPictures:orderFulfillmentId')}
            </Label>
            <Input
              type="text"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setOrderFulfillmentId(e.target.value)
              }
            />
          </FormGroup>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button
          disabled={pictureIds.length === 0 || orderFulfillmentId.length === 0}
          onClick={execute}
        >
          {i18n.t('OrderFulfillmentPictures:link')}
        </Button>
        <Button onClick={() => setIsOpen(false)} color="danger">
          {i18n.t('Common:cancel')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LinkOrderFulfillmentPicturesModal;
